<div class="full-page">
  <div style="display: flex; justify-content: space-between">
    <div>
      <mat-form-field>
        <input
          matInput
          [(ngModel)]="searchString"
          (input)="doSearch()"
          placeholder="{{ settings.lang.searchVolunteer }}"
          [ngModelOptions]="{ standalone: true }"
        />
        <mat-icon matSuffix (click)="clearSearch()">clear</mat-icon>
      </mat-form-field>
      <br />
    </div>
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="quickAdd()"
        class="primary"
      >
        {{ settings.lang.addVolunteer }}
      </button>
    </div>
  </div>

  <data-grid [settings]="helpers" class="grow-item"></data-grid>
</div>
